import { Component, EventEmitter, Input, Output } from '@angular/core'
import { UploadedFileComponent } from '../uploaded-file/uploaded-file.component'
import { FormArray, FormGroup, ReactiveFormsModule } from '@angular/forms'
import { UploadInputComponent } from '../upload-input/upload-input.component'
import { NgClass } from '@angular/common'
import { NgxTippyModule } from 'ngx-tippy-wrapper'
import { UploadTooltipMessagePipe } from '../../pipes/upload-tooltip-message.pipe'
import { ProgressCircleComponent } from '@app/v2/shared/components/progress-circle/progress-circle.component'

@Component({
  selector: 'app-multiple-file-upload',
  templateUrl: './multiple-file-upload.component.html',
  styleUrls: ['./multiple-file-upload.component.scss'],
  standalone: true,
  imports: [ProgressCircleComponent, UploadedFileComponent, UploadInputComponent, NgClass, ReactiveFormsModule, NgxTippyModule, UploadTooltipMessagePipe]
})
export class MultipleFileUploadComponent {
  public isFileDraggedOver: boolean = false

  @Input() uploadProgressList!: number[]
  @Input() useImageCropper!: boolean
  @Input() canEditFileName!: boolean
  @Input() displayFilename!: boolean
  @Input() maxFilesToUpload!: number
  @Input() maxFileSize!: number
  @Input() minFileSize!: number
  @Input() tooltip!: string
  @Input() isMultipleInput!: boolean
  @Input() fileList!: FormArray<FormGroup>
  @Input() accept!: string
  @Input() height: string = ''
  @Input() width: string = ''
  @Input() warningMessage: string = ''
  @Input() hint: string = ''
  @Output() toggleGallery: EventEmitter<number> = new EventEmitter<number>()
  @Output() deleteFile: EventEmitter<number> = new EventEmitter<number>()
  @Output() cropImage: EventEmitter<number> = new EventEmitter<number>()
  @Output() nameChanged: EventEmitter<number> = new EventEmitter<number>()
  @Output() fileChanged: EventEmitter<File[]> = new EventEmitter<File[]>()

  public get filesObjects(): FormGroup[] {
    return this.fileList.controls as FormGroup[]
  }

  /**
   * @description Listen to file changes and handle the validation on the uploaded files
   * @param event Event
   */
  public onFileChange(event: Event): void {
    event.preventDefault()
    event.stopPropagation()
    this.isFileDraggedOver = false
    const files = Array.from(((<DragEvent>event).dataTransfer as DataTransfer).files)
    if (!files?.length) return
    this.fileChanged.emit(files)
  }

  /**
   * @description Changes property based on drag event
   * @param event Event
   */
  public fileDragOver(event: Event): void {
    event.preventDefault()
    event.stopPropagation()
    this.isFileDraggedOver = true
  }

  /**
   * @description Changes property based on drag event
   * @param event Event
   */
  public fileDragLeave(event: Event): void {
    event.preventDefault()
    event.stopPropagation()
    this.isFileDraggedOver = false
  }
}
